'use client'
import {
  useAnalytics_default
} from "./chunk-4UUAL6L3.mjs";
import {
  CONSENT_COOKIE_NAME
} from "./chunk-T2NN7R53.mjs";

// src/cookie/useCookieConsent.ts
import { setItem } from "@wbk/utils";
var useCookieConsent = () => {
  const { showConsent, setCookieConsent } = useAnalytics_default();
  const saveConsent = (data) => {
    setItem(CONSENT_COOKIE_NAME, JSON.stringify(data));
    setCookieConsent({ type: "update", data });
  };
  const acceptConsent = (props) => {
    const data = {
      analytics_storage: "denied",
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
      date: (/* @__PURE__ */ new Date()).toISOString()
    };
    if (typeof props === "undefined") {
      data.analytics_storage = "granted";
      data.ad_storage = "granted";
      data.ad_user_data = "granted";
      data.ad_personalization = "granted";
    } else {
      data.analytics_storage = props.analytics_storage;
      data.ad_storage = props.ad_storage;
      data.ad_user_data = props.ad_user_data;
      data.ad_personalization = props.ad_personalization;
    }
    saveConsent(data);
  };
  const rejectConsent = () => {
    const data = {
      analytics_storage: "denied",
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
      date: (/* @__PURE__ */ new Date()).toISOString()
    };
    saveConsent(data);
  };
  return {
    showConsent,
    acceptConsent,
    rejectConsent
  };
};

export {
  useCookieConsent
};
//# sourceMappingURL=chunk-2LLIFHBT.mjs.map